import { render, staticRenderFns } from "./FutureAddressStreetField.vue?vue&type=template&id=bf85e324"
import script from "./FutureAddressStreetField.vue?vue&type=script&lang=js"
export * from "./FutureAddressStreetField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports